// extracted by mini-css-extract-plugin
export default {"about__advertising-video":"about_about__advertising-video__q4oSN","circle":"about_circle__AuYRK"};